import u from "./ghl-ui.es1267.js";
var i = !1;
function l(r, a) {
  var n = a.nationalNumber, o = a.defaultCountry, e = a.metadata;
  if (i && e.isNonGeographicCallingCode(r))
    return "001";
  var t = e.getCountryCodesForCallingCode(r);
  if (t)
    return t.length === 1 ? t[0] : u(n, {
      countries: t,
      defaultCountry: o,
      metadata: e.metadata
    });
}
export {
  l as default
};
